export const REACT_APP_MAILCHIMP_URL = "";
export const REACT_APP_MAILCHIMP_U = "";
export const REACT_APP_MAILCHIMP_ID = "";
export const LINKEDIN = "https://www.linkedin.com/in/jinal-vasoya-a039391b4/";
export const GITHUB = "https://github.com/Jinal-Vasoya";
export const GOOGLE =
  "https://mail.google.com/mail/u/0/#inbox?compose=CllgCJqbzFZtTnnNStbdRCbwGPPbvCmlDSzLHkjFPDwhlVMnJRQvVQFlLDWpVMgzNgkNfjQsDZg";
